import axios from 'axios';
import { queryClient } from '../lib/queryClient';
import { CURRENT_MEMBER_QUERY_KEY } from '../lib/queryKeys';
import { getRuntimeEnv } from '../utils/runtimeEnv';

const API_URL = getRuntimeEnv('REACT_APP_API_URL') || 'http://localhost:8080/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    // A 403 means the UI acted on a role the backend does not grant (typically a stale
    // session): drop the cached session so the next render re-reads it from /members/me.
    if (error.response?.status === 403) {
      queryClient.invalidateQueries({ queryKey: CURRENT_MEMBER_QUERY_KEY });
    }
    return Promise.reject(error);
  }
);

export default api;
